import {
  Stack,
  Tab,
  Tabs,
  TabList,
  TabPanel,
  TabPanels,
} from '@tonic-one/react';
import { useNavigate } from 'react-router-dom';
import NavBack from 'src/components/Common/NavBack';
import Expressions from './Expressions';
import KeywordLists from './KeywordLists';
import { useTranslation } from 'react-i18next';
import { useLayoutStore } from '@Models/useLayoutModel';
// policySettings/dlp/expressions
// policySettings/dlp/templates
const DataIdentifiers = () => {
  const { t } = useTranslation(['common', 'policy']);
  const navigate = useNavigate();
  const { layoutHeight } = useLayoutStore();
  return (
    <Stack position="relative" height={layoutHeight}>
      {/* height = 46px */}
      <NavBack
        fixed={false}
        onBack={() => {
          navigate(-1);
        }}
        style={{ padding: '7px 24px 7px 7px' }}
      />
      <Tabs height="100%">
        {/* height = 40px */}
        <TabList>
          <Tab>{t('policy.dataIdentifiers.expressions.title')}</Tab>
          <Tab>{t('policy.dataIdentifiers.keywordLists.title')}</Tab>
        </TabList>
        <TabPanels height="100%">
          <TabPanel height="100%">
            <Expressions />
          </TabPanel>
          <TabPanel height="100%">
            <KeywordLists />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Stack>
  );
};
export default DataIdentifiers;
